window.addEventListener("load", function () {
  // Khởi tạo Swiper với cấu hình hiển thị một phần slide tiếp theo
  const swiperFeature = new Swiper(".swiperFeature", {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 0,
    loop: true,
    effect: "coverflow",
    coverflowEffect: {
      rotate: 0,
      stretch: 383,
      depth: 300,
      slideShadows: true,
    },
    breakpoints: {
      751: {
        slidesPerView: "auto",
        coverflowEffect: {
          stretch: 383,
        },
      },
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});
